export default __webpack_public_path__ + "static/media/expand-icon.c5efa4d0.svg";